import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { CardGroup } from '@cli-types/next-adapter/forms.js'
import { toCamelCase, toPascalCase } from '@cli-utils/text.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'

export function parseCardGroups(allFormFields: SchemaField[], schemaLabel: string): CardGroup[] {
  const sections = allFormFields.filter((f) => f.type === 'section' && f.fields)
  const nonSections = allFormFields.filter((f) => f.type !== 'section' && !isLayoutField(f.type))

  if (sections.length === 0) {
    const title = nonSections[0]?.label || nonSections[0]?.name || schemaLabel
    return [
      {
        title,
        description: '',
        hint: '',
        varPrefix: toCamelCase(nonSections[0]?.name || 'form'),
        componentName: `${toPascalCase(nonSections[0]?.name || 'form')}Card`,
        fields: nonSections,
        flatFields: flattenFields(nonSections).filter((f) => !isLayoutField(f.type))
      }
    ]
  }

  const groups: CardGroup[] = []
  for (const section of sections) {
    const innerFields = section.fields || []
    groups.push({
      title: section.label || section.name,
      description: section.description || '',
      hint: section.hint || '',
      varPrefix: toCamelCase(section.name),
      componentName: `${toPascalCase(section.name)}Card`,
      fields: innerFields,
      flatFields: flattenFields(innerFields).filter((f) => !isLayoutField(f.type))
    })
  }

  if (nonSections.length > 0) {
    const title = nonSections[0]?.label || nonSections[0]?.name || 'General'
    groups.unshift({
      title,
      description: '',
      hint: '',
      varPrefix: toCamelCase(nonSections[0]?.name || 'general'),
      componentName: `${toPascalCase(nonSections[0]?.name || 'General')}Card`,
      fields: nonSections,
      flatFields: flattenFields(nonSections).filter((f) => !isLayoutField(f.type))
    })
  }

  return groups
}
